'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dItem$002dState from "./mealorama.-Store-Cart-Item-State.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dItem$002dState$0024$0024anon$00242 from "./mealorama.-Store-Cart-Item-State$$anon$2.js";
var $p;
function $s_Lmealorama_StoreCartItemState$__needed__Lmealorama_StoreCartItemState() {
  $m_Lmealorama_StoreCartItemState$();
  return $t_Lmealorama_StoreCartItemState$__needed;
}
export { $s_Lmealorama_StoreCartItemState$__needed__Lmealorama_StoreCartItemState as $s_Lmealorama_StoreCartItemState$__needed__Lmealorama_StoreCartItemState };
function $s_Lmealorama_StoreCartItemState$__gotten__Lmealorama_StoreCartItemState() {
  $m_Lmealorama_StoreCartItemState$();
  return $t_Lmealorama_StoreCartItemState$__gotten;
}
export { $s_Lmealorama_StoreCartItemState$__gotten__Lmealorama_StoreCartItemState as $s_Lmealorama_StoreCartItemState$__gotten__Lmealorama_StoreCartItemState };
/** @constructor */
function $c_Lmealorama_StoreCartItemState$() {
  this.amb = null;
  $n_Lmealorama_StoreCartItemState$ = this;
  $t_Lmealorama_StoreCartItemState$__needed = new $j_mealorama$002e$002dStore$002dCart$002dItem$002dState$0024$0024anon$00242.$c_Lmealorama_StoreCartItemState$$anon$2("needed", 0);
  $t_Lmealorama_StoreCartItemState$__gotten = new $j_mealorama$002e$002dStore$002dCart$002dItem$002dState$0024$0024anon$00242.$c_Lmealorama_StoreCartItemState$$anon$2("gotten", 1);
  this.amb = new ($j_mealorama$002e$002dStore$002dCart$002dItem$002dState.$d_Lmealorama_StoreCartItemState.r().C)([$s_Lmealorama_StoreCartItemState$__needed__Lmealorama_StoreCartItemState(), $s_Lmealorama_StoreCartItemState$__gotten__Lmealorama_StoreCartItemState()]);
}
export { $c_Lmealorama_StoreCartItemState$ as $c_Lmealorama_StoreCartItemState$ };
$p = $c_Lmealorama_StoreCartItemState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartItemState$;
/** @constructor */
function $h_Lmealorama_StoreCartItemState$() {
}
export { $h_Lmealorama_StoreCartItemState$ as $h_Lmealorama_StoreCartItemState$ };
$h_Lmealorama_StoreCartItemState$.prototype = $p;
$p.aIc = (function() {
  return this.amb.a6();
});
var $d_Lmealorama_StoreCartItemState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartItemState$, "mealorama.StoreCartItemState$", ({
  H5: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_StoreCartItemState$ as $d_Lmealorama_StoreCartItemState$ };
var $n_Lmealorama_StoreCartItemState$;
function $m_Lmealorama_StoreCartItemState$() {
  if ((!$n_Lmealorama_StoreCartItemState$)) {
    $n_Lmealorama_StoreCartItemState$ = new $c_Lmealorama_StoreCartItemState$();
  }
  return $n_Lmealorama_StoreCartItemState$;
}
export { $m_Lmealorama_StoreCartItemState$ as $m_Lmealorama_StoreCartItemState$ };
var $t_Lmealorama_StoreCartItemState$__needed = null;
function $u_Lmealorama_StoreCartItemState$__needed(x) {
  $t_Lmealorama_StoreCartItemState$__needed = x;
}
export { $t_Lmealorama_StoreCartItemState$__needed as $t_Lmealorama_StoreCartItemState$__needed, $u_Lmealorama_StoreCartItemState$__needed as $u_Lmealorama_StoreCartItemState$__needed };
var $t_Lmealorama_StoreCartItemState$__gotten = null;
function $u_Lmealorama_StoreCartItemState$__gotten(x) {
  $t_Lmealorama_StoreCartItemState$__gotten = x;
}
export { $t_Lmealorama_StoreCartItemState$__gotten as $t_Lmealorama_StoreCartItemState$__gotten, $u_Lmealorama_StoreCartItemState$__gotten as $u_Lmealorama_StoreCartItemState$__gotten };
//# sourceMappingURL=mealorama.-Store-Cart-Item-State$.js.map
